import type { WordCollection } from "../collection.types";

export const gratitudeGatheringCollection: WordCollection = {
  id: "gratitude-gathering",
  title: "Gratitude & Gathering",
  icon: "account-group",
  isWordlistViewable: true,
  startDate: new Date(new Date().getFullYear(), 10, 15), // November 15th
  endDate: new Date(new Date().getFullYear(), 11, 15), // December 15th (overlapping with Long Night)
  words: [
    "bond",
    "bread",
    "circle",
    "community",
    "family",
    "fruit",
    "generous",
    "grain",
    "harmony",
    "invitation",
    "joy",
    "link",
    "love",
    "memory",
    "praise",
    "provision",
    "soup",
    "table",
    "tie",
    "tribute",
    "unity",
    "wealth",
    "welcome",
    "wine",
  ],
};
